import axios from 'axios';

// Base URL for the FastAPI backend. In production REACT_APP_BACKEND_URL is empty,
// so requests go to the same origin (`/api`), which OpenLiteSpeed proxies to
// 127.0.0.1:8017. For local dev, set REACT_APP_BACKEND_URL=http://localhost:8017.
const BACKEND = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');
export const API_BASE = `${BACKEND}/api`;

const api = axios.create({ baseURL: API_BASE });

// Attach the JWT (if present) to every request.
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
